import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager", webpackExports: ["FirstLoginGate"] */ "/app/src/components/auth/FirstLoginGate.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/dev/msw-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppErrorBoundary"] */ "/app/src/components/layout/app-error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegistration"] */ "/app/src/components/pwa/service-worker-registration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppToasts"] */ "/app/src/components/ui/app-toasts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingSpinner"] */ "/app/src/components/ui/loading-spinner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/app/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/root-fonts.css");
;
import(/* webpackMode: "eager" */ "/app/src/styles/toasts.css");
